import React from "react";
import { mapHomeIndexToDataTable as mapData } from "./Helper";
import ReusableDndTable from "src/components/table/ReusableDndTable/ReusableDndTable";
import GetHomeIndexColumns from "./ColumnDefinition/HomeIndexColumn/GetHomeIndexColumns";

const HomeIndexTable = ({
  data,
  handleOpenPopup,
  handleDelete,
  onDragEnd,
  status,
}) => {
  const columns = GetHomeIndexColumns({
    handleOpenPopup,
    handleDelete,
    status,
  });

  return (
    <ReusableDndTable
      columns={columns}
      data={mapData(data)}
      maxHeight={500}
      onDragEnd={onDragEnd}
    />
  );
};

export default HomeIndexTable;
